<template>
  <div
    class="sub-container"
    @click="otherClick"
    ref="refroot"
    :data-type="subtitleObj.type"
    :style="{backgroundColor : subtitleObj && subtitleObj.type === 'video' ? '#f0f0f8':'transparent'}"
  >
    <div :style="maskTopStyle"></div>
    <div :style="maskLeftStyle"></div>
    <div :style="maskRightStyle"></div>
    <div :style="maskBottomStyle"></div>
    <div :style="editorStyle" id="subtitleEditor-container" class="subtitleEditor-container">
      <EditToolbar></EditToolbar>
      <CanvasWater :canvasSize="canvasSize" v-show="isPlaying" />
      <!-- <div class="sprite-help-content sprite-help-content-dashed active" style="width:200px;height:120px;"></div> -->
    </div>
    <div class="textbox" v-if="tbvisible">
      <div
        ref="subtextbox"
        class="textbox-container"
        @blur="updateTextbox"
        :style="textboxStyle"
        contenteditable
        v-html="text"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import EditToolbar from "../editToolbar";
import CanvasWater from "./canvasWater";
//import AnimEditor from "../../../../static/animengine/js/neweditor";
//import subtitleUILoader from "../../../../static/animengine/js/subtitle/subtitleUI";

//subtitleUILoader(AnimEditor);
//#f0f0f8 :style="editorStyle"

export default {
  name: "CanvasContainer",
  data() {
    return {
      text: "",
      tbvisible: false,
      textboxStyle: {},
      isPlaying: false,
      containerSize: {},
      editorOffset: {},
      canvasSize: {
        width: 0,
        height: 0,
      },
    };
  },
  props: {
    //type: String
  },

  mounted() {
    this.$store.commit('save_WindowSubtitle', {
      width: document.body.clientWidth,
      height: document.body.clientHeight,
    });
    this.$bus.emit("EditorSetOption_vue", {
      data: true,
      source: "subtitle"
    });
    window.addEventListener("resize", this.resize, false);

    //this.$store.commit("subtitle/setSubtitleEditor", this.subtitleEditor);
    var _this = this;

    eve.on("subtitle_selected_change", function (ui) {
      _this.$store.commit(
        "subtitle/setSubIndex",
        _this.subtitleEditor.textUIs.indexOf(ui)
      );
    });

    this.inputfuc = function (ui) {
      _this.$store.commit("subtitle/toggle_isPreventDefault", false);
      _this.tbvisible = true;
      ui.hide();
      _this.text = ui.json.text;
      var data = ui.json;
      //console.log("ui.editSize.width", ui.editSize.width);
      _this.textboxStyle = {
        fontSize: data.font.fontSize * ui.editor.scale + "px",
        fontFamily: '"' + data.font.fontFamilyUrl.split("/").pop() + '"',
        fontWeight: data.font.fontWeight,
        fontStyle: data.font.fontStyle,
        textDecoration: data.font.textDecoration,
        textAlign: data.font.textAlign,
        color: data.font.color,
        opacity: data.font.opacity,
        top: ui.editSize.top + _this.editorOffset.top + "px",
        left: ui.editSize.left + _this.editorOffset.left + "px",
        width: ui.editSize.width + "px",
        height: "auto",
        writingMode: "inherit",
        transformOrigin: "0px 0px 0px",
        lineHeight: data.font.fontSize * ui.editor.scale + "px",
        //transform: "scale(" + ui.editor.scale + ")",
        //lineHeight: 1,
        letterSpacing: 0,
      };

      //console.log('_this.textboxStyle', _this.textboxStyle.lineHeight, _this.$refs.subtextbox);

      _this.pastefuc = (e) => {
        e.preventDefault();
        e.stopPropagation();
        var text;
        var clp = (e.originalEvent || e).clipboardData;
        if (clp === undefined || clp === null) {
          text = window.clipboardData.getData("text") || "";
          if (text !== "") {
            if (window.getSelection) {
              var newNode = document.createElement("span");
              newNode.innerHTML = text;
              window.getSelection().getRangeAt(0).insertNode(newNode);
            } else {
              document.selection.createRange().pasteHTML(text);
            }
          }
        } else {
          text = clp.getData("text/plain") || "";
          if (text !== "") {
            document.execCommand("insertText", false, text);
          }
        }
      };

      setTimeout(() => {
        var node = _this.$refs.subtextbox;
        //console.log('_this.textboxStyle', _this.textboxStyle.lineHeight, _this.$refs.subtextbox);
        if (window.getSelection) {
          let selection = window.getSelection();
          let range = document.createRange();
          //console.log(node);
          range.selectNodeContents(node);
          selection.removeAllRanges();
          selection.addRange(range);
        }
        node.addEventListener("paste", _this.pastefuc);
      }, 200);
    };

    //文本输入
    eve.on("subtitle_input_text", this.inputfuc);
    this.$bus.on("subtitle_input_text_stop", this.updateTextbox);

    //时间轴播放
    this.$bus.on("timeline_play_all", (data) => {
      _this.isPlaying = data.isPlay;
      if (data.isPlay) {
        //console.log('timeline_play_all', data.isPlay, data.time)
        _this.subtitleEditor.play(Math.ceil(data.time * 60));
      } else {
        //console.log('timeline_play_all', data.isPlay, data.time)
        _this.subtitleEditor.stop(Math.ceil(data.time * 60));
      }
    });
    this.$bus.on("playSubtitleTime", (data) => {
      if (_this.isPlaying) {
        _this.subtitleEditor.playing(data.frame);
        return;
      }
      _this.subtitleEditor.stop(data.frame);
    });

    if (this.subtitleEditor && this.TOOL) {
      this.subtitleEditor.setOption({
        width: this.TOOL.clientWidth,
        height: this.TOOL.clientHeight,
        rootId: "subtitleEditor-container",
      });
      this.subtitleEditor.loadUI();
      this.subtitleEditor.stop(0);
    }

    this.resize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resize, false);
    var node = this.$refs.subtextbox;
    if (node) node.removeEventListener("paste", this.pastefuc);
    eve.off("subtitle_input_text", this.inputfuc);
    this.$bus.on("subtitle_input_text_stop", this.updateTextbox);
  },
  watch: {
    subtitleObj(val) {
      //console.log('subtitleObj', this.subtitleObj)
      if (val) {
        this.subtitleUIObj = this.subtitleEditor;
        //console.log('this.subtitleObj.type;', this.subtitleObj)
        this.type = this.subtitleObj.type;
        if (this.subtitleEditor) {
          this.subtitleEditor.setOption({
            width: this.TOOL.clientWidth,
            height: this.TOOL.clientHeight,
            rootId: "subtitleEditor-container",
          });
        }
        this.subtitleEditor.loadUI();
        this.subtitleEditor.stop(0);
      }
      this.resize();
    },
    editorStyle (val) {
      setTimeout(() => {
        this.$emit('editorStyle');
      }, 100);
    }
  },
  methods: {
    resize() {
      //let h = this.$refs.refroot.offsetHeight;
      if (this.$refs.refroot) {
        this.containerSize = {
          width: this.$refs.refroot.offsetWidth,
          height: this.$refs.refroot.offsetHeight,
        };
      }

      //console.log("this.containerSize", this.containerSize);
    },
    otherClick(e) {
      if (this.tbvisible) return;
      this.$store.commit("subtitle/setSubIndex", -1);
    },
    updateTextbox() {
      this.$store.commit("subtitle/toggle_isPreventDefault", true);
      //return;
      this.tbvisible = false;
      if (!this.$refs.subtextbox) return;
      let modifiedText = this.$refs.subtextbox.innerHTML
        .replace(/<div><br><\/div>/g, "\n")
        .replace(/<div.*?>/g, "\n")
        .replace(/<br.*?>/g, "")
        .replace(/<\/div>|&nbsp;|<\/?span.*?>/g, "");
      while (
        modifiedText.length > 1 &&
        modifiedText.charCodeAt(modifiedText.length - 1) === 10
      ) {
        modifiedText = modifiedText.substring(0, modifiedText.length - 1);
      }
      // 鼠标点击文本框以外的地方时更新到画布
      if (this.text !== modifiedText) {
        if(modifiedText === "") modifiedText = "添加字幕内容";
        if (this.selectTextUI) this.selectTextUI.updateText(modifiedText);
      }
      if (this.selectTextUI) this.selectTextUI.show();
      this.$bus.emit("subtitle_updateItemText_vue", this.selectTextUI.json);
      document.getElementById("subtitle").scrollTop = 0;
      document.getElementById("subtitle").scrollLeft = 0;
    },
  },
  computed: {
    ...mapGetters([
      "SetPanel_Size",
      "MaterialPane_Size",
      "TopNav_Size",
      "Tool_Size",
      "Window_Size",
      "TOOL",
    ]),
    ...mapGetters({
      subtitleObj: "subtitle/subtitleObj",
      selectTextUI: "subtitle/selectTextUI",
      subtitleEditor: "subtitle/subtitleEditor",
    }),
    editorStyle() {
      if (!this.subtitleObj) return;
      let style = {
        position: "relative",
      };
      let left = 0;
      let top = 0;
      let width = 0;
      let height = 0;
      if (this.subtitleObj.type === "draft") {
        width = this.TOOL.clientWidth;
        height = this.TOOL.clientHeight;
        top = this.TOOL.fixTop + 40;
        // left = this.TOOL.fixLeft + 246;
        // left = 388;
        left = this.MaterialPane_Size.width + this.TOOL.fixLeft;
      } else {
        var maxSize = 0,
          multiple = 0.9;
        if (this.containerSize.width > (this.containerSize.height * 16) / 9) {
          maxSize = ((this.containerSize.height * multiple) / 9) * 16;
        } else {
          maxSize = this.containerSize.width * multiple;
        }
        width = maxSize;
        height = (maxSize / 16) * 9;
        left = (this.containerSize.width - width) / 2;
        top = (this.containerSize.height - height) / 2 + 15;
      }
      if (this.subtitleEditor) {
        this.subtitleEditor.setOption({
          width: width,
          height: height,
          rootId: "subtitleEditor-container",
        });
      }
      this.editorOffset.top = top;
      this.editorOffset.left = left;
      style.width = width + "px";
      style.height = height + "px";
      style.top = top + "px";
      style.left = left + "px";
      this.canvasSize.width = width;
      this.canvasSize.height = height;
      return style;
    },
    maskTopStyle() {
      const style = {
        backgroundColor: "#f0f0f8",
        position: "absolute",
      };
      if (this.subtitleObj && this.subtitleObj.type === "draft") {
        style.width = "100%";
        style.height = this.TOOL.fixTop + 40 + "px";
        style.top = 0;
        style.left = 0;
      } else {
      }
      //console.log('maskTopStyle', style);
      return style;
    },
    maskLeftStyle() {
      const style = {
        backgroundColor: "#f0f0f8",
        position: "absolute",
      };
      if (this.type === "draft") {
        style.width = this.TOOL.fixLeft + this.MaterialPane_Size.width + "px";
        style.height = this.Tool_Size.height - this.TOOL.fixTop * 2 - 40 + "px";
        style.top = this.TOOL.fixTop + 40 + "px";
        style.left = 0;
      } else {
      }

      return style;
    },
    maskRightStyle() {
      const style = {
        backgroundColor: "#f0f0f8",
        position: "absolute",
      };
      if (this.type === "draft") {
      } else {
      }

      return style;
    },
    maskBottomStyle() {
      const style = {
        backgroundColor: "#f0f0f8",
        position: "absolute",
      };
      if (this.type === "draft") {
      } else {
      }

      return style;
    },
  },
  components: {
    EditToolbar,
    CanvasWater,
  },
};
</script>

<style lang="scss" scoped>
.sub-container {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #f0f0f8;
  // .subtitleEditor-container {
  //   background-color: #fff;
  // }
  .textbox {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    .textbox-container {
      position: absolute;
      border: 1px dashed #000;
      height: auto;
      word-break: break-word;
      outline: none;
      white-space: pre-wrap;
      box-sizing: content-box;
      -webkit-user-select: text !important;
      user-select: text !important;
      -webkit-background-clip: text;
      background-clip: text;
      caret-color: black;
      // -webkit-user-modify: read-write-plaintext-only;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/editCanvas/canvasContainer.vue